import React from 'react';
import ItemRow from './ItemRow';
import CurrencySymbol from '../General/CurrencySymbol';
import { personShoppingTotal } from '../../services/shoppingList';


const PersonBox = (props) => {
    
    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return "https://graph.facebook.com/" + userData.FBID + "/picture?type=large";
	    }
	    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile;
	    }
	    return "https://weblight.imgix.net/avatars/man.png";
    }

    const items = props.items || [];
    const shoppinglistRows = items.map(sl => <ItemRow key={sl.itemID} {...sl}></ItemRow>);
    const total = personShoppingTotal(items);

    return (
    <div className="kt-portlet kt-widget kt-widget--general-3">
        <div className="kt-portlet__head p-0">
            <div className="kt-portlet__head-label p-3">
                <img alt="item" src={buildAvatarUrl(props)} className="avatar avatar-sm mr-3" />
                <div>
                    <h3 className="kt-portlet__head-title">{props.FirstName} {props.LastName}</h3>
                    <div className="kt-widget__desc">
                        {items.length} {items.length === 1 ? 'item' : 'items'}
                        {' · '}
                        <CurrencySymbol></CurrencySymbol>{total.toFixed(2)}
                    </div>
                </div>
            </div>
        </div>
        <div className="kt-portlet__body kt-portlet__body--fit">
            {shoppinglistRows}
            
        </div>
    </div>

    );
}

export default PersonBox;